import { motion } from "framer-motion";
import { ThemeContext } from "../contexts/ThemeProvider";
import { useContext } from "react";
import { TranslateKey } from "../contexts/LanguageProvider";
import { LanguageContext } from "../contexts/LanguageProvider";

const Section = ({
  number,
  titleKey,
  bodyKey,
}: {
  number: number;
  titleKey: TranslateKey;
  bodyKey: TranslateKey;
}) => {
  const { colorsObj } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="mb-8"
    >
      <h3
        className="text-xl font-semibold mb-2"
        style={{ color: colorsObj.colorText }}
      >
        {number}. {t(titleKey)}
      </h3>
      <p
        className="leading-relaxed"
        style={{ color: colorsObj.colorText + "50" }}
        dangerouslySetInnerHTML={{ __html: t(bodyKey) }}
      />
    </motion.div>
  );
};

export default function PrivacyPolicy() {
  const { colorsObj } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);
  return (
    <main
      className=" px-6 py-12 lg:px-48"
      style={{
        backgroundColor: colorsObj.colorBackground,
        color: colorsObj.colorText,
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold mb-4 mt-24">{t("privacy-title")}</h1>
        <p className="text-sm text-gray-500 mb-12">
          {t("privacy-last-updated")}
        </p>
      </motion.div>

      <Section number={1} titleKey="privacy-1-title" bodyKey="privacy-1-body" />
      <Section number={2} titleKey="privacy-2-title" bodyKey="privacy-2-body" />
      <Section number={3} titleKey="privacy-3-title" bodyKey="privacy-3-body" />
      <Section number={4} titleKey="privacy-4-title" bodyKey="privacy-4-body" />
      <Section number={5} titleKey="privacy-5-title" bodyKey="privacy-5-body" />
      <Section number={6} titleKey="privacy-6-title" bodyKey="privacy-6-body" />

      <Section number={7} titleKey="privacy-7-title" bodyKey="privacy-7-body" />
      <Section number={8} titleKey="privacy-8-title" bodyKey="privacy-8-body" />
      <Section number={9} titleKey="privacy-9-title" bodyKey="privacy-9-body" />
    </main>
  );
}
